import React from 'react';
import styles from './region-entity-table.module.scss';

export const RegionTableHeader = ({ region, comparing, isMobile }) => {
  const hasDisplayData = (entityObj) => {
    return entityObj.capacityMl || entityObj.dams || entityObj.storageLevel;
  };
  const hasNonCouncilFacilities =
    region.byRegionByEntity.filter(
      (x) => x.entity !== 'Council' && hasDisplayData(x)
    ).length > 0;

  return (
    <tr>
      <td colSpan={isMobile ? 1 : 2}>
        <div>
          <div>
            <span className={styles.tableHeaderText}>
              {comparing ? region.name : 'In this region'}
            </span>
          </div>
          {!comparing && !isMobile && hasNonCouncilFacilities && (
            <div>
              <span className={styles.cellInfoText}>
                Click on a water entity for more details about its finances.
              </span>
            </div>
          )}
          {/* {!comparing && hasNonCouncilFacilities && (
            <div>
              <span className={styles.cellInfoText}>
                Water services are managed by water entities and the council.
                Click on a water entity for more details about its finances.
              </span>
            </div>
          )} */}
        </div>
      </td>
    </tr>
  );
};



// WEBPACK FOOTER //
// ./src/components/region-entity-table/region-table-header.js